<template>
  <BaseModal
    :is-editable="false"
    :is-archivable="false"
    :is-visible="isVisible"
    size="xl"
    @hideModal="hideModal()"
  >
    <template #header>
      {{ $t('views.agreements.list.options.createAgreementItems') }}
    </template>
    <template #body>
      <b-row align-h="around">
        <b-col>
          <b-col cols="12">
            <p>{{ $t('views.agreements.list.createAgreementItemsCollection') }}:</p>
            <ul>
              <li v-for="(agreement, index) in getAgreements" :key="'idClient_'+index">
                {{ agreement.idClientName }}
              </li>
            </ul>
          </b-col>
          <AgreementItems
            :create-agreement-items-multi="true"
            :data="agreement"
            :violations="[]"
            :is-invalid="() => {return false}">
          </AgreementItems>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <button type="button" class="mt-2 btn btn-danger" @click="hideModal()">{{$t('buttons.cancel')}}</button>
        </b-col>
        <b-col>
          <button
            type="button"
            class="btn btn-success float-right"
            @click="createAgreementItems()"
          >
            {{$t('buttons.accept')}}
          </button>
        </b-col>
      </b-row>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import AgreementItems from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementItems'

export default {
  name: 'CreateAgreementItemsModal',
  components: {
    AgreementItems,
    BaseModal
  },

  props: ['id', 'idCollection'],

  data () {
    return {
      agreement: {
        agreementItems: [],
        agreementVariants: []
      }
    }
  },
  computed: {
    ...mapGetters({
      isVisible: 'agreements/createAgreementItemsModal/isVisible',
      response: 'agreements/createAgreementItemsModal/response',
      getAgreements: 'agreements/list/getAgreementsForMassEdit'
    })
  },
  watch: {
    isVisible (val) {
      if (val) {
        this.fetchAgreements({ idAgreements: this.idCollection })
      }
    },
    response () {
      this.hideModal()
    }
  },
  methods: {
    createAgreementItems () {
      this.createAgreementItemsForCollection({
        body: {
          'agreementItems': this.agreement.agreementItems,
          'agreementVariants': this.agreement.agreementVariants,
          'agreements': this.idCollection
        }
      })
    },
    hideModal () {
      this.$emit('reset')
      this.toggleCreateAgreementItemsModal()
      this.agreement.agreementItems = []
      this.agreement.agreementVariants = []
    },
    ...mapMutations({
      toggleCreateAgreementItemsModal: 'agreements/createAgreementItemsModal/toggleModal'
    }),
    ...mapActions({
      createAgreementItemsForCollection: 'agreements/createAgreementItemsModal/createAgreementItemsForCollection',
      fetchAgreements: 'agreements/list/fetchAgreementsForMassEdit'
    })
  }
}
</script>
